// console.log('Kobe JS loaded');

// Product Calculator Globals
const MODE_AREA_TO_QTY = 0
const MODE_QTY_TO_AREA = 1
const MODE_GET_PRICE   = 2

const VAR_METADATA_M2    = 0
const VAR_METADATA_PRICE = 1

const WHOLE_NUMBER_DEFAULT = '1'
const DECIMAL_NUMBER_DEFAULT = '.00'

// ONLY ASSIGN/MODIFY IN initProductCalculator()
let M2_PER_PACK = 0;
let QTY_PRICE;
let QTY_AREA;
let QTY_CALC_INPUT;
let QTY_PRODUCT_INPUT;
let MINUS_BTN;
let PLUS_BTN;

$(function () {
    // https://stackoverflow.com/a/995193
    $.fn.inputFilter = function() {
        return this.on("input keydown keyup mousedown mouseup select contextmenu drop focusout", function(e) {
            if (
                /^\s*\d*\s*$/.test(this.value) || // Any number or whitespace
                /^[^\.\D]{0,}\.[^\.\D]{0,}$/.test(this.value) // {any numbers}.{any numbers}
            ) { 
                // Do nothing, input passed
            } else {
                // Failed, don't change value
                if (this.hasOwnProperty("oldValue")) {
                    this.value = this.oldValue
                } else {
                    this.value = WHOLE_NUMBER_DEFAULT + DECIMAL_NUMBER_DEFAULT
                }
            }
            this.oldValue = this.value
            this.oldSelectionStart = this.selectionStart;
            this.oldSelectionEnd = this.selectionEnd;
        })
    }
    $.fn.inputLinker = function(mode = MODE_AREA_TO_QTY) {
        return this.on("input keydown keyup mousedown mouseup select contextmenu drop focusout click", function(e) {
            if (mode === MODE_AREA_TO_QTY) {
                QTY_PRODUCT_INPUT.val(calculateValues(mode))
            } else if (mode === MODE_QTY_TO_AREA) {
                QTY_CALC_INPUT.val(calculateValues(mode))
            }

            // Update Price
            const new_price = calculateValues(MODE_GET_PRICE);
            QTY_PRICE.text('$' + new_price);

            // Update Area
            QTY_AREA.text(calculateValues(MODE_QTY_TO_AREA) + ' m²')
        })
    }
}(jQuery))

function getVariationMetadata(data = VAR_METADATA_M2) {
    variant_title = ''
    $('.tt-swatches-container-js .tt-wrapper select').each(function(i) {
        variant_title += (variant_title.length > 1) ? ' / ' + $( this ).val() : $( this ).val()
    })
    variant_info = $('div[data-var-title="' + variant_title + '"]')
    return (data === VAR_METADATA_M2) ? variant_info.attr('data-var-m2') : variant_info.attr('data-var-price').replace('$', '')
}

function calculateValues(mode = MODE_AREA_TO_QTY) {
    // const quantity = (typeof quantity_input === 'undefined') ? other_input.val() : quantity_input.val()
    // Get M2_PER_PACK from global above
    if (mode === MODE_AREA_TO_QTY) {
        return Math.ceil(QTY_CALC_INPUT.val() / M2_PER_PACK);
    } else if (mode === MODE_QTY_TO_AREA) {
        return (M2_PER_PACK * QTY_PRODUCT_INPUT.val()).toFixed(2)
    } else if (mode === MODE_GET_PRICE) {
        const price = getVariationMetadata(VAR_METADATA_PRICE).replace(',',''); // Remove thousands separator
        return (QTY_PRODUCT_INPUT.val() * price).toFixed(2)
    }
}

/**
 * Wait for the specified element to appear in the DOM. When the element appears,
 * provide it to the callback.
 *
 * @param selector a jQuery selector (eg, 'div.container img')
 * @param callback function that takes selected element (null if timeout)
 * @param maxtries number of times to try (return null after maxtries, false to disable, if 0 will still try once)
 * @param interval ms wait between each try
 */
function waitForEl(selector, callback, maxtries = false, interval = 100) {
    const poller = setInterval(() => {
      const el = jQuery(selector)
      const retry = maxtries === false || maxtries-- > 0
      if (retry && el.length < 1) return // will try again
      clearInterval(poller)
      callback(el || null)
    }, interval)
}

$(function () {
    // Creates borders for images in tabs
    const tab_images = $('div[class*="simplebannerstemplate"].insulation-tabs img')
    if (tab_images.length) {
        tab_images.wrap('<div class="img-wrapper"/>')
    }

    // Replace search bar placeholder
    const search_bar_desktop = $('#shopify-section-header-template .tt-desktop-header form[role="search"] input.tt-search-input')
    if (search_bar_desktop.length) {
        search_bar_desktop.attr('placeholder', 'Search our products')
    }

    // Product Calculator
    const qty_calc_data = $('#qty-calc-metadata')
    if (qty_calc_data.length) {
        initProductCalculator()
    }
})

function initProductCalculator() {
    QTY_PRICE = $("#qty-calc-price");
    QTY_AREA = $("#qty-calc-area");
    QTY_CALC_INPUT = $('#qty-calc-input');
    QTY_PRODUCT_INPUT = $('form[action="/cart/add"] input[name="quantity"]')
    MINUS_BTN = $('form[action="/cart/add"] .minus-btn')
    PLUS_BTN = $('form[action="/cart/add"] .plus-btn')

    // Enforce numbers only
    QTY_CALC_INPUT.inputFilter()

    // Link inputs together
    QTY_CALC_INPUT.inputLinker()
    QTY_PRODUCT_INPUT.inputLinker(MODE_QTY_TO_AREA)
    MINUS_BTN.inputLinker(MODE_QTY_TO_AREA)
    PLUS_BTN.inputLinker(MODE_QTY_TO_AREA)

    // Reset values on variation change
    // Dropdowns are added via JS, so we bind DOMSubtreeModified to detect changes

    // DOMSubtreeModified was formally removed from Chrome 2024-06-23, replaced with MutationObserver
    // $('.tt-swatches-container-js').bind('DOMSubtreeModified', function() {
    //     setProductCalculatorValues();
    // })

    target = $('.tt-swatches-container-js')[0];

    var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.addedNodes.length) {
                    setProductCalculatorValues();
                }
            });
        }
    );

    config = { attributes: false, childList: true, subtree: true };

    // Start observing
    observer.observe(target, config);
}

// Set default values
// Dropdowns are added dynamically by theme JS, we need to wait for those elements to appear
function setProductCalculatorValues() {
    waitForEl('.tt-swatches-container-js .tt-wrapper select', (el) => {
        M2_PER_PACK = getVariationMetadata()
        QTY_CALC_INPUT.val(calculateValues(MODE_QTY_TO_AREA))
        QTY_PRICE.text('$' + calculateValues(MODE_GET_PRICE))
        QTY_AREA.text(calculateValues(MODE_QTY_TO_AREA) + ' m²')
    })
}